import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Drawer as ArcDrawer, cssVar } from 'arc';
import { useDrawerRender } from '../../drawers/components/drawer-context-provider';
import { useAppName } from '../../app-name/app-name';

type DrawerProps = React.ComponentProps<typeof ArcDrawer>;

export function Drawer(props: DrawerProps) {
    const drawerRenderProps = useDrawerRender();
    const appName = useAppName();
    const isInline =
        typeof props.variant !== 'undefined'
            ? props.variant === 'inline'
            : typeof drawerRenderProps?.drawer.inline !== 'undefined'
            ? drawerRenderProps?.drawer.inline === true
            : appName === 'first-responder'
            ? true
            : false;

    return (
        <ArcDrawer
            {...props}
            variant={isInline ? 'inline' : 'overlay'}
            placement={isInline ? 'left' : 'right'}
            borderRightWidth={isInline ? '1px' : undefined}
            borderRightColor={isInline ? cssVar('arc.colors.selected.default') : undefined}
        />
    );
}
